import { DBDef_FlowSheet } from '@app/advisor-content-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_FlowSheet } from '../../_entity/flow-sheet/ModuleFE_FlowSheet.js';
import { ModuleFE_SmartDoc } from '../../_entity/smart-doc/ModuleFE_SmartDoc.js';
import { Manager_FlowSheet } from '../../ui/_managers/Manager_FlowSheet/Manager_FlowSheet.js';
import { ConfigDialogKeys_AdvisorContent, ConfigDialogs_AdvisorContent_Dialogs, ConfigDialogs_AdvisorContent_Labels } from '../../ui/config-dialogs/index.js';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_FlowSheet,
    dbDef: DBDef_FlowSheet,
    tag: ['Fs', 'Flow Sheet'],
    modulesToAwait: [ModuleFE_FlowSheet, ModuleFE_SmartDoc],
    ManagerComponent: Manager_FlowSheet,
    extraMenuSections: () => [{
            actions: ConfigDialogKeys_AdvisorContent.map(key => ({
                label: ConfigDialogs_AdvisorContent_Labels[key],
                action: () => ConfigDialogs_AdvisorContent_Dialogs[key].show(),
            })),
        }],
});
export const WorkHubItem_FlowSheet = WorkHubItem;
export const UtilObject_FlowSheet = UtilObject;
export const SearchItem_FlowSheet = SearchItem;
//# sourceMappingURL=flow-sheet.js.map